import { render, staticRenderFns } from "./PermissionsTable.vue?vue&type=template&id=4f9efe23"
import script from "./PermissionsTable.js?vue&type=script&lang=js&external"
export * from "./PermissionsTable.js?vue&type=script&lang=js&external"
import style0 from "./PermissionsTable.vue?vue&type=style&index=0&id=4f9efe23&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports